import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'outline';
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap',
        variant === 'default' && 'bg-muted text-muted-foreground',
        variant === 'accent' && 'bg-primary/10 text-primary',
        variant === 'outline' && 'border border-border text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}
